import { Context, useContext } from 'react'
import { match } from 'react-router'

import RouterContext, { TContextValue } from './RouterContext'

type TParam = {
  [key: string]: any
}
type UseRouterContext = {
  match: match<TParam>
}
const useRouter = (): UseRouterContext =>
  useContext(RouterContext as Context<TContextValue>)

export default useRouter
